import { Typography, Box } from '@mui/material';
import { ReactNode } from 'react';

type ListsProps = {
  list: string[];
  children: ReactNode;
};

/**
 * Reusable list renderer with icon or prefix before each item.
 */
const Lists: React.FC<ListsProps> = ({ list, children }) => {
  return (
    <Box>
      {list.map((item, idx) => (
        <Box key={idx} sx={{ display: 'flex', alignItems: 'flex-start', my: 1, minWidth: 0 }}>
          <Box sx={{ pt: '3px', flexShrink: 0, mr: 1 }}>{children}</Box>

          <Typography
            variant="body1"
            sx={{
              display: 'block',
              whiteSpace: 'pre-line',
              textAlign: 'left',
              m: 0,
              pl: 0,
              textIndent: 0,
            }}
          >
            {item}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default Lists;
